import React, { Fragment } from "react";
import classNames from "classnames";

const TextField = ({ field }) => {
  const {
    input,
    className,
    placeholder,
    type,
    meta: { touched, error },
    style = null,
    min
  } = field;
  if (min) input.min = "0";
  return (
    <Fragment>
      <input
        {...input}
        onBlur={input.onBlur}
        onChange={input.onChange}
        className={classNames(className, touched && error && "has-error")}
        placeholder={placeholder}
        type={type}
        style={style ? style : {}}
      />
      {touched && error && (
        <small style={{ color: "red" }}>
          <i className="fa fa-exclamation-triangle" /> {error}
        </small>
      )}
    </Fragment>
  );
};

export default TextField;
